export const changeUrl = (pathname: string, state: Object = {}) => {
  const hostOrigin = window.location.origin;
  window.history.pushState(state, '', `${hostOrigin}/${pathname}`);
};
